var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed inner",domProps:{"innerHTML":_vm._s(_vm.item.code)}})
}
var staticRenderFns = []

export { render, staticRenderFns }